module.exports = __webpack_public_path__ + "static/secure_documentation-4e6a49023fe9766b03eedb77d297281e.jpg";